import React from "react";
import {
  ChecklistItemCard,
  ChecklistItemCardProps,
} from "./ChecklistItemCard";

export type PendingChecklistItemCardProps = Omit<
  ChecklistItemCardProps,
  "variant"
>;

export const PendingChecklistItemCard: React.FC<
  PendingChecklistItemCardProps
> = (props) => {
  return <ChecklistItemCard {...props} variant="pending" />;
};
